import React from 'react';
import { SvgIcon } from '@material-ui/core';

const WebSVGIcon = () => (
  <SvgIcon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path d="M 7.5 18.234375 C 7.261719 18.234375 7.03125 18.148438 6.851562 17.992188 L 0.851562 12.742188 C 0.640625 12.554688 0.515625 12.285156 0.515625 12 C 0.515625 11.714844 0.640625 11.445312 0.851562 11.257812 L 6.851562 6.007812 C 7.261719 5.652344 7.882812 5.691406 8.242188 6.101562 C 8.597656 6.511719 8.558594 7.132812 8.148438 7.492188 L 2.996094 12 L 8.148438 16.507812 C 8.457031 16.777344 8.566406 17.210938 8.421875 17.597656 C 8.277344 17.980469 7.910156 18.234375 7.5 18.234375 Z M 7.5 18.234375 " />
        <path d="M 16.5 18.234375 C 16.089844 18.234375 15.722656 17.980469 15.578125 17.597656 C 15.433594 17.210938 15.542969 16.777344 15.851562 16.507812 L 21.003906 12 L 15.851562 7.492188 C 15.441406 7.132812 15.402344 6.511719 15.757812 6.101562 C 16.117188 5.691406 16.738281 5.652344 17.148438 6.007812 L 23.148438 11.257812 C 23.363281 11.445312 23.484375 11.714844 23.484375 12 C 23.484375 12.285156 23.363281 12.554688 23.148438 12.742188 L 17.148438 17.992188 C 16.96875 18.148438 16.738281 18.234375 16.5 18.234375 Z M 16.5 18.234375 " />
        <path d="M 9.75 20.484375 C 9.4375 20.484375 9.148438 20.335938 8.960938 20.089844 C 8.773438 19.839844 8.71875 19.515625 8.808594 19.21875 L 13.308594 4.21875 C 13.398438 3.871094 13.671875 3.601562 14.019531 3.515625 C 14.367188 3.429688 14.734375 3.539062 14.980469 3.804688 C 15.222656 4.066406 15.304688 4.441406 15.191406 4.78125 L 10.691406 19.78125 C 10.566406 20.199219 10.183594 20.484375 9.75 20.484375 Z M 9.75 20.484375 " />
      </g>
    </svg>
  </SvgIcon>
);

export default WebSVGIcon;
